module.exports = __webpack_public_path__ + "static/visual-7fa116ae66f3635d6af35fcea065277b.svg";